import { Head } from "@inertiajs/react"
import { SonarLayout } from "@/components/sonar"
import { DSDCenter, type DSDCenterData } from "@/components/dsd-center"

interface DsdCenterPageProps {
  data: DSDCenterData
}

export default function DsdCenterPage({ data }: DsdCenterPageProps) {
  return (
    <>
      <Head title="DSD Center">
        <meta
          name="description"
          content="Planning Centre + Lab economics — gross vs PC credit vs True Sale, utilisation, credit by client, volume mix and invoicing lag."
        />
        <meta property="og:title" content="DSD Center" />
        <meta
          property="og:description"
          content="Planning Centre + Lab economics — gross vs PC credit vs True Sale, utilisation, credit by client, volume mix and invoicing lag."
        />
      </Head>
      <SonarLayout>
        <DSDCenter data={data} />
      </SonarLayout>
    </>
  )
}
